import { useState, useRef, useMemo, useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import { apiAgent } from "../../axiosConfig";
import { Link } from "react-router-dom";
import ReactDOM from "react-dom";
import { useHighConfidenceContext } from '../views/news_feed/high_confidence_context';
import Avatar from "../../design_system/components/Avatar/Avatar.jsx";
import { Loader } from "../../design_system/components/Loader.jsx";
import { Button } from "../../design_system/components/Button/Button.jsx";

const AnShortProfile = ({
    containerClass="text_caption",
    innerClass="text_caption",
    messageTheme='background-white right',
    innerStyle={marginLeft: -140},
    ...props
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const current_user = useSelector(state => state.current_user.user);
    const { shortProfileFields } = useHighConfidenceContext();
    const prospectFields = shortProfileFields.prospectFields;

    const renderRelationShips = (item) => {
        return (
            <div className="windfall-card__field">
                <div className="support-s-caps windfall-card__field-label">{item.label}</div>
                <div className="body-s-semibold windfall-card__field-value" style={{display: "flex", flexDirection: "column"}}>
                    {props.prospect.spouse_relationships && props.prospect.spouse_relationships.length > 0 && (
                        <div className="an_shortprofile_box">
                            <span style={{paddingRight: '6px'}}>Spouse: </span>
                            <div style={{width: 122}}>
                                {props.prospect.spouse_relationships.map((item, index) => (
                                    <Link className="text_link" style={{textDecoration: "none"}} to={"/prospects/" + item.id} target="_blank">{index >= 1 && ",  "}{item.name}</Link>
                                ))}
                            </div>
                        </div>
                    )}
                    {props.prospect.other_relationships && props.prospect.other_relationships.length > 0 && (
                        <div className="an_shortprofile_box">
                            <span style={{paddingRight: '14px'}}>Other: </span>
                            <div style={{width: 122}}>
                                {props.prospect.other_relationships.map((item, index) => (
                                    <Link className="text_link" style={{textDecoration: "none"}} to={"/prospects/" + item.id} target="_blank">{index >= 1 && ",  "}{item.name}</Link>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    const calculateLeft = useMemo(() => {
        if (props.parent) {
            return props.parent === "Avatar" ? props.element.hoverDiv.x : props.element.hoverDiv.x;
        } else {
            return props.element.x;
        }
    }, [props.parent]);

    const calculatePosition = useMemo(() => {
        if (props.parent === "Avatar") {
            if ((props.parentDistance && Math.abs(props.parentDistance.dTop) < Math.abs(props.parentDistance.dBottom))) {
                return { top: props.element.hoverDiv.y + props.element.hoverDiv.height - 8};
            } else {
                return { bottom: window.innerHeight - props.element.hoverDiv.y};
            }
        } else {
            if ((props.parentDistance && Math.abs(props.parentDistance.dTop) < Math.abs(props.parentDistance.dBottom))) {
                return { top: props.element.hoverDiv.y + props.element.hoverDiv.height - 8};
            } else {
                return { bottom: window.innerHeight - props.element.hoverDiv.y};
            }
        }
    }, [props.parent, props.parentDistance, props.parentDistance.dTop, props.parentDistance.dBottom]);

    return ReactDOM.createPortal(
        current_user ? (
        <div style={{ position: "fixed", padding: "16px 0px", zIndex: 999, backgroundColor: "transparent", left: calculateLeft, ...calculatePosition }} onMouseOver={() => props.setComponentState("isHovering", true)}
        onMouseLeave={() => props.setComponentState("isHovering", false)}
        >
            {props.isHovering ? (
                <div className="hover_card">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar
                            name={props.prospect.name || props.prospect.company}
                        />
                        <div className="windfall-card__prospect-info">
                            <div className="body-m-bold windfall-card__name">{props.prospect.name || props.prospect.company}</div>
                            {props.prospect.name && (
                                <div className="body-s-semibold windfall-card__headline">
                                    {props.prospect.designation}
                                </div>
                            )}
                        </div>
                    </div>
                {
                    isLoading ?
                    <div className="windfall-card__loader"><Loader isLoading={true} Size="Large" /></div>
                    :
                    <>
                        {prospectFields.length > 0 && (
                            <div className="body-s-semibold windfall-card__section-title">
                                Profile Information
                            </div>
                        )}

                        {prospectFields.map((item, index) => (
                            (item.key !== "relationships") && (
                                <>
                                    <div className="windfall-card__field">
                                        <div className="support-s-caps windfall-card__field-label">{item.label}</div>
                                        <div className="body-s-semibold windfall-card__field-value">
                                            {props.prospect[item.key]
                                                ? (item.key === "assigns" || item.key === "tags") ? props.prospect[item.key].map(assign => assign.name).join(", ") : props.prospect[item.key].replace(/\n/g, ', ')
                                                : '\u00A0'}
                                        </div>
                                    </div>
                                    {(index !== prospectFields.length - 1) && <div className="windfall-card__separator"></div>}
                                </>
                            )
                            ||
                            (item.key === "relationships" && (
                                renderRelationShips(item)
                            ))
                        ))}

                        {props.prospect.custom_answers.map(answer => {
                        if (prospectFields.map(field => field.label).includes(answer.question) && answer.answer != null && answer.answer.length > 0) {
                            return (
                                <div className="windfall-card__field">
                                    <div className="support-s-caps windfall-card__field-label">{answer.question}</div>
                                    <div className="body-s-semibold windfall-card__field-value">
                                        {answer.answer}
                                    </div>
                                </div>
                            );
                        } else {
                            return null;
                        }
                        })}
                        <Button
                            Type="Secondary"
                            Size="Small"
                            onClick={() => window.open(`/prospects/${props.prospect.id}`)}
                        >
                            Profile
                        </Button>
                    </>
                }
                </div>
            ) : null}
        </div>
        ) : null,
        document.getElementById("hover_card")
    );
};

export default AnShortProfile;
